import { useMutation } from 'Data/Api'
import { useDataValue } from 'Simple/Data'
import {
  notifyError,
  useNotifications,
  notifySuccess,
} from 'Logic/Notifications.js'
import mutation from './mutation.graphql.js'
import { color } from 'Data/validate.js'

let EXCLUDE_KEYS = ['setting_ids', 'level', 'app_id', 'apps']

export default function useDataOnSubmit(props, data) {
  let [, notify] = useNotifications()

  let [, executeMutation] = useMutation(mutation)
  let configuration_id = useDataValue({
    context: 'selected',
    path: 'configuration_id',
    viewPath: props.viewPath,
  })

  return async function onSubmit({ value, originalValue }) {
    let updates = []
    let inserts = []

    // // validate colors
    if (value.theme === 'custom') {
      if (
        !value.themeOverride ||
        !value.themeOverride.main ||
        !value.themeOverride.dark ||
        !value.themeOverride.light
      ) {
        notify(
          notifyError(
            'Invalid color configuration. Please select all three colors.'
          )
        )
        return true
      }

      if (
        !color(value.themeOverride.main) ||
        !color(value.themeOverride.dark) ||
        !color(value.themeOverride.light)
      ) {
        notify(
          notifyError(
            'Invalid color configuration. Please check all the colors and make sure they are correct hex values.'
          )
        )
        return true
      }
    }

    Object.keys(value)
      .filter(key => !EXCLUDE_KEYS.includes(key))
      .map(key => {
        if (
          key in originalValue &&
          value[key] !== originalValue[key] &&
          originalValue.setting_ids[key]
        ) {
          updates.push({
            where: { id: { _eq: originalValue.setting_ids[key] } },
            _set: {
              value:
                key === 'themeOverride'
                  ? // map the colors to path in design tokens
                    {
                      'colors.theme.dark': value.themeOverride.dark,
                      'colors.theme.light': value.themeOverride.light,
                      'colors.theme.main': value.themeOverride.main,
                    }
                  : value[key],
            },
          })
        } else if (!(key in originalValue)) {
          inserts.push({
            configuration_id,
            key,
            value:
              key === 'themeOverride'
                ? {
                    'colors.theme.dark': value.themeOverride.dark,
                    'colors.theme.light': value.themeOverride.light,
                    'colors.theme.main': value.themeOverride.main,
                  }
                : value[key],
          })
        }
        return null
      })

    let app_id_changed = value.app_id !== originalValue.app_id

    if (inserts.length === 0 && updates.length === 0 && !app_id_changed) {
      return
    }

    let mutationResponse = await executeMutation({
      inserts,
      updates,
      insert_settings: inserts.length !== 0,
      update_settings: updates.length !== 0,
      configuration_id,
      app_id: value.app_id || null,
      update_configuration: app_id_changed,
    })

    if (mutationResponse.error) {
      notify(
        notifyError(
          'Something went wrong. Please, try again or contact support if the problem persists.'
        )
      )
      return
    }

    notify(notifySuccess('Settings Updated!'))
  }
}
